exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-59dc0502] .el-carousel{height:100%}.link-title[data-v-59dc0502]{white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
